module.exports = __webpack_public_path__ + "img/Mauritania.2bee32d4.svg";